import { render, staticRenderFns } from "./OTagInput.vue?vue&type=template&id=b3a47c66&scoped=true&"
import script from "./OTagInput.vue?vue&type=script&lang=js&"
export * from "./OTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a47c66",
  null
  
)

export default component.exports